import React, { useRef } from 'react'
import Modal from '../../../../shared/ui/Modal/Modal'
import s from './styles/SaveListNameModal.module.scss'

export default function SaveListNameModal({
	isOpen,
	onClose,
	value,
	onChange,
	onSubmit,
	defaultPlaceholder,
	errNameList,
}) {
	const inputRef = useRef(null)
	const canSave = String(value || '').trim().length > 0

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Save list"
			subtitle="This list will include the currently selected students."
			width={520}
			maxHeight={320}
			initialFocusRef={inputRef}
			footerButtons={[
				{
					id: 'back',
					text: 'Back',
					variant: 'secondary',
					onClick: onClose,
				},
				{
					id: 'save',
					text: 'Save',
					variant: 'primary',
					onClick: onSubmit,
					disabled: !canSave,
				},
			]}
		>
			<div className={s.content}>
				<label className={s.label}>List name</label>
				<input
					ref={inputRef}
					className={s.input}
					value={value}
					onChange={e => onChange?.(e.target.value)}
					placeholder={defaultPlaceholder}
				/>
			</div>
		</Modal>
	)
}
